import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Row, Col, Alert } from "react-bootstrap";
import { meta, contactConfig, positions } from "../../content_option";
import "../contact/style.css";
import "./style.css";

export const ContactTab = () => {
  const { i18n } = useTranslation();
  const language = (i18n.language || "en").split("-")[0];

  const [formData, setFormdata] = useState({
    email: "",
    name: "",
    message: "",
    loading: false,
    show: false,
    alertmessage: "",
    variant: "",
  });

  const handleChange = (e) => {
    setFormdata({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormdata((prev) => ({ ...prev, loading: true }));
    try {
      const response = await fetch("https://formspree.io/f/xovdnagj", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: formData.name, email: formData.email, message: formData.message }),
      });

      if (response.ok) {
        setFormdata({
          loading: false,
          alertmessage: language === "ko" ? "메시지가 성공적으로 전송되었습니다!" : "Your message was sent successfully!",
          variant: "success",
          show: true,
          name: "",
          email: "",
          message: "",
        });
      } else {
        throw new Error(language === "ko" ? "메시지 전송에 실패했습니다." : "Failed to send message.");
      }
    } catch (error) {
      setFormdata((prev) => ({
        ...prev,
        loading: false,
        alertmessage: `${language === "ko" ? "전송 실패" : "Failed"}: ${error.message}`,
        variant: "danger",
        show: true,
      }));
      document.getElementsByClassName("co_alert")[0]?.scrollIntoView();
    }
  };

  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title> Contact | {meta.title}</title>
      </Helmet>
      <div className="join-body">
        <h1 className="join-heading">Join Rosota</h1>
        <p className="join-sub">
          {language === "ko"
            ? "대한민국을 대표하는 수술로봇 기업을 함께 세워나갈 분들을 찾습니다."
            : "We're looking for the people who will build Korea's leading surgical-robotics company with us."}
        </p>

        <h3 className="nl-archive-title">Open Positions</h3>
        {positions.map((p) => (
          <div className="position-card" key={p.title}>
            <h4>{p.title}</h4>
            <div className="position-tags">
              {p.tags.map((tag) => (
                <span className="position-tag" key={tag}>{tag}</span>
              ))}
            </div>
            <p className="position-desc">{language === "ko" ? p.desc.ko : p.desc.en}</p>
          </div>
        ))}

        <Row className="mb-4 mt-5">
          <Col lg="12">
            <h3 className="nl-archive-title" style={{ marginBottom: 6 }}>Get in touch</h3>
            <address style={{ marginBottom: 4 }}>
              <strong>Email:</strong> <a href={`mailto:${contactConfig.YOUR_EMAIL}`}>{contactConfig.YOUR_EMAIL}</a>
            </address>
            <p className="join-sub" style={{ marginBottom: 24 }}>
              {language === "ko" ? "최고의 인재들과 함께 성장하세요." : "Grow with the best."}
            </p>
          </Col>
          <Col lg="12">
            <Alert
              variant={formData.variant}
              className={`rounded-0 co_alert ${formData.show ? "d-block" : "d-none"}`}
              onClose={() => setFormdata({ ...formData, show: false })}
              dismissible
            >
              <p className="my-0">{formData.alertmessage}</p>
            </Alert>
          </Col>
          <Col lg="12" className="d-flex align-items-center">
            <form onSubmit={handleSubmit} className="contact__form w-100">
              <Row>
                <Col lg="6" className="form-group">
                  <input className="form-control" name="name" placeholder="Full Name" value={formData.name || ""} type="text" required onChange={handleChange} />
                </Col>
                <Col lg="6" className="form-group">
                  <input className="form-control rounded-0" name="email" placeholder="Email" type="email" value={formData.email || ""} required onChange={handleChange} />
                </Col>
              </Row>
              <textarea
                className="form-control rounded-0"
                name="message"
                placeholder={language === "ko" ? "당신의 배경, 관심사, 그리고 Rosota와 함께하고 싶은 이유를 들려주세요." : "Tell us about your background, interests, and why you want to join Rosota."}
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
              <br />
              <Row>
                <Col lg="12" className="form-group">
                  <button className="btn ac_btn" type="submit" disabled={formData.loading}>
                    {formData.loading ? "Sending..." : "Submit Application"}
                  </button>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </div>
      <div className={formData.loading ? "loading-bar" : "d-none"}></div>
    </HelmetProvider>
  );
};
